/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:40
 * @LastEditors: bbq
 * @LastEditTime: 2020-11-07 15:47:22
 */
import React, { Component } from "react";
import { getSysFieldid } from '@platform/api';
import Dropdown from '../Dropdown';
import Tooltip from '../Tooltip';
import Menu from '../Menu';
import Tabs from "../Tabs";
const { Item } = Menu;
const { TabPane } = Tabs;
require("./TabsControl.less");

/**
 * defaultKey:默认选中的tab
 * children:tab的每一项
 * disableTab：禁用的tab
 */
class TabsControl extends Component {
    constructor(props) {
        super(props);
        let keyList = React.Children.map(this.props.children, item => {
            return item.key;
        });

        this.state = {
            currentIndex: this.props.defaultKey,
            currentKey: keyList[this.props.defaultKey],
            keyList: keyList,
            calculateWidthFlag: false, // 计算tab切换内容区的宽度
            scrollWidth: 0, // tab切换内容区的宽度
        };
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        let { keyList } = this.state;
        if (newProps.defaultKey != this.props.defaultKey) {
            this.setState({
                currentIndex: newProps.defaultKey,
                currentKey: keyList[newProps.defaultKey],
            });
        }
    }

    componentDidMount() {
        let { showMoreBtn = false } = this.props;
        let { calculateWidthFlag = false } = this.props;
        if (showMoreBtn && !calculateWidthFlag) {
            let scrollWidth = this.tabsDom.scrollWidth;
            // this.scrollWidth = scrollWidth;
            this.setState({
                calculateWidthFlag: true,
                scrollWidth,
            });
        }
    }

    componentDidUpdate() {
        let { showMoreBtn = false } = this.props;
        if (showMoreBtn) {
            setTimeout(() => {
                let activeDom = this.tabsDom.querySelector('.tab_title.active');
                activeDom && activeDom.scrollIntoView();
            }, 300);
        }
    }

    tab_title_index(index) {
        return index === this.state.currentIndex
            ? "tab_title active"
            : "tab_title";
    }

    selectMoreList(key) {
        let { keyList } = this.state;
        this.setState({
            currentIndex: key,
            currentKey: keyList[key],
        });
    }

    render() {
        let menuList = React.Children.map(this.props.children, (item, index) => {
            return <Item key={item.key} onClick={this.selectMoreList.bind(this, index)}>{item.props.children}</Item>;
        });

        let menu = <Menu selectedKeys={[this.state.currentKey]}>{menuList}</Menu>;
        let { domWidth = 0, showMoreBtn = false } = this.props;
        let { keyList, scrollWidth } = this.state;
        let renderMoreFlag = showMoreBtn && scrollWidth > parseInt(domWidth);
        return (
            <div className="lightapp-component-TabLi" fieldid={getSysFieldid('tabs-area')}>
                <div className="lightapp-component-tabList" ref={dom => (this.tabsDom = dom)}>
                    {React.Children.map(this.props.children, (element, index) => {
                        return (
                            <React.Fragment>
                                <div
                                    onClick={() => {
                                        if (this.props.disableTab) {return;}
                                        this.setState(
                                            { currentIndex: index, currentKey: keyList[index] },
                                            element.props.clickFun,
                                        );
                                    }}
                                    className={this.tab_title_index(index)}
                                >
                                    <p>{element.props.children}</p>
                                    <p />
                                </div>
                                <span className="splitter"></span>
                            </React.Fragment>
                        );
                    })}
                </div>
                {
                    renderMoreFlag &&
                    <Dropdown
                        trigger={['click']}
                        overlay={menu}
                        animation="slide-up"
                    >
                        <Tooltip
                            placement="top"
                            // overlay={'expandFlag ? json.index_001 : json.index_000'}
                            delayHide={1}
                            delayShow={500}
                            trigger={'click'}
                        >
                            <span className="lightapp-component-tabMore"><i className="iconfont icon-chuansuo-you"></i></span>
                        </Tooltip>
                    </Dropdown>
                }
            </div>
        );
    }
}

class TabsNext extends Component {
    constructor(props) {
        super(props);
        this.funMap = {};
        this.state = { activeKey: props.defaultKey };
    }

    onChange = activeKey => {
        this.setState({ activeKey }, this.funMap[activeKey]);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.defaultKey != this.props.defaultKey) {
            this.setState({ activeKey: newProps.defaultKey });
        }
    }

    render() {
        const tabPaneArray = [];
        let activeKey = this.state.activeKey ?? 0;
        let { type = 'line', className = '', extendFlatButton, tabBarExtraContent } = this.props;
        if(extendFlatButton) {
            tabBarExtraContent = <div className="tabs-flat-button">{extendFlatButton}</div>;
        }

        React.Children.forEach(this.props.children, (element, index) => {
            this.funMap[String(element.key || index)] = element.props.clickFun || (() => { });
            if (index === activeKey) {activeKey = String(element.key || index);}
            tabPaneArray.push(<TabPane
                tab={element}
                disabled={this.props.disableTab}
                key={String(element.key || index)}
            >
            </TabPane>);
        });
        return tabPaneArray.length ? <Tabs
            {...this.props}
            tabBarExtraContent = { tabBarExtraContent }
            type={type}
            className={className}
            activeKey={String(activeKey)}
            onChange={this.onChange}
        >
            {tabPaneArray}
        </Tabs> : null;
    }
}

export default TabsNext;
